import { useState } from "react";
import { useNavigate } from "react-router-dom";

// Define types for the function parameters
type ApiFunction = () => Promise<{ data?: any; response?: { status: number } }>;
type OnSuccessFunction = (data: any) => Promise<void> | void;
type OnFailureFunction = () => Promise<void> | void;

function useApi() {
    const [loading, setLoading] = useState<boolean>(false);

    const navigate = useNavigate();

    async function call(
        func: ApiFunction,
        onSuccess?: OnSuccessFunction,
        onFailure?: OnFailureFunction
    ): Promise<void> {
        setLoading(true);

        try {
            let initial_response = await func();
            if (initial_response && initial_response.data) {
                const { data } = initial_response;
                if (data && onSuccess) {
                    await onSuccess(data);
                }
            } else if (initial_response.response?.status === 403) {
                await handleAuthFailure();
            } else {
                onFailure && (await onFailure());
            }
        } catch (error) {
            console.error("An error occurred:", error);
        } finally {
            setLoading(false);
        }
    }

    async function handleAuthFailure(): Promise<void> {
        navigate("/login");
    }

    return {
        call,
        loading,
    };
}

export { useApi };
